<template>
  <div class="container-fluid pt-0 mt-2">
    <AddShipment
      v-if="showModal"
      :show="showModal"
      :onCancel="closeModal"
      @showSuccessPopup="handleSuccessPopup"
    />

    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <Drawer
      :shipment="viewDrawer"
      :visible="isModalVisible"
      @update:visible="isModalVisible = false"
      @isLoading="handleLoading"
    />
    <div class="row card_row">
      <div class="available_container">
        <div class="card_content">
          <div
            class="img_div"
            style="background-color: rgba(222, 234, 242, 0.5)"
          >
            <img src="../../../assets/images/Check All.svg" />
          </div>
          <div class="card_text">
            <span class="title">{{ shipmentSummary.all }}</span>
            <span class="info">{{ $t("all-shipment") }}</span>
          </div>
        </div>
      </div>

      <div>
        <div class="card_content">
          <div
            class="img_div"
            style="background-color: rgba(218, 236, 224, 0.5)"
          >
            <img src="../../../assets/images/Data Pending.svg" />
          </div>
          <div class="card_text">
            <span class="title">{{ shipmentSummary.ongoing }}</span>
            <span class="info"> {{ $t("ongoing-shipment") }} </span>
          </div>
        </div>
      </div>

      <div>
        <div class="card_content">
          <div
            class="img_div"
            style="background-color: rgba(248, 235, 206, 0.5)"
          >
            <img src="../../../assets/images/Check All.svg" />
          </div>
          <div class="card_text">
            <span class="title">{{ shipmentSummary.completed }}</span>
            <span class="info"> {{ $t("completed-shipment") }} </span>
          </div>
        </div>
      </div>
    </div>
    <!-- Table start -->
    <div
      style="
        background-color: #fff;
        max-height: 40rem;
        overflow-y: auto;
        width: 100%;
        height: fit-content;
        margin-top: 2rem;
      "
    >
      <div class="card-body" style="overflow-x: auto; width: 100%">
        <div class="table-responsive">
          <div class="row mb-2">
            <div class="col-sm-12 col-md-12">
              <div
                class="d-flex align-items-center justify-content-between"
                style="gap: 0.4rem"
              >
                <div
                  style="
                    width: 14rem;
                    background-color: #fff;
                    border-radius: 8px;
                    border: 1px solid rgba(183, 195, 205, 1);
                  "
                >
                  <select
                    class="form-control"
                    name="condition"
                    v-model="condition"
                    @change="sortDevices"
                    style="
                      width: 13rem;
                      background-color: transparent !important;
                      cursor: pointer;
                    "
                  >
                    <option
                      v-for="option in shippingOptions"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ option.label }}
                    </option>
                  </select>
                </div>
                <TableSearch @handleSearch="handleSearch" />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div ref="content" class="table-responsive">
              <table id="order-listing" class="table table-hover display">
                <thead style="background-color: rgba(240, 244, 251, 0.6)">
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        :checked="
                          checkedShipments.length === paginatedData.length
                        "
                        @click="headingCheckClick"
                      />
                    </th>
                    <th
                      :key="index"
                      v-for="(column, index) in tableColumns"
                      style="cursor: pointer; text-align: left"
                    >
                      {{ column[0] }}
                      <span
                        class="arrow"
                        :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                      ></span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(shipment, index) in paginatedData"
                    :key="index"
                    class="user-row cursor-pointer"
                    style="border-bottom: unset"
                    @click="showdrawer(shipment)"
                    :class="{
                      'data-table-bg': index % 2 !== 0,
                    }"
                  >
                    <td>
                      <input
                        @click.stop="handleCheck(shipment.id)"
                        type="checkbox"
                        :checked="
                          checkedShipments.some(
                            (selectedShipment) =>
                              shipment.id === selectedShipment
                          )
                        "
                        :value="shipment.id"
                      />
                    </td>
                    <td>#{{ shipment.shipmentId }}</td>
                    <td class="text-capitalize">
                      {{ `${shipment.shipmentType} freight` || "" }}
                    </td>

                    <td v-if="shipment.containers && shipment.containers.length > 0">
                      {{ shipment.containers[0].containerNumber }}
                    </td>
                    <td v-else>
                      {{ "-" }}
                    </td>
                    <td
                      class="d-flex align-items-center position-relative"
                      v-click-outside="hideImeis"
                      v-if="shipment.containers && shipment.containers[0].assignedDevices && shipment.containers[0].assignedDevices.length > 0"
                    >
                      {{ shipment.containers[0].assignedDevices[0].imei }}
                      <button
                        class="d-flex justify-content-center align-items-center border-0 ml-2 outline-none font-weight-bold"
                        style="
                          width: 31px;
                          height: 31px;
                          border-radius: 50%;
                          background-color: #e9ecf2;
                        "
                        @click="showImeis($event, index)"
                        v-if="shipment.containers[0].assignedDevices.length > 1"
                      >
                        <span class="text-primary font-12">
                          +{{
                            shipment.containers[0].assignedDevices.length - 1
                          }}
                        </span>
                      </button>

                      <div
                        class="dropdown-menu border-0 shadow"
                        style="top: 52px; left: 0; border-radius: 10px"
                        v-show="containerToshowImeis === index"
                      >
                        <p
                          v-for="(device, index) in shipment.containers[0]
                            .assignedDevices"
                          :key="index"
                          class="mb-0"
                        >
                          {{ device.imei }}
                        </p>
                      </div>
                    </td>
                    <td v-else>
                      {{ "-" }}
                    </td>

                    <td>
                      {{ formatDate(shipment.departureDate) }}
                    </td>

                    <td>
                      {{ formatDate(shipment.eta) }}
                    </td>

                    <td>
                      {{ shipment.vesselName || shipment.flightNumber }}
                    </td>
                    <td>
                      <span
                        :class="
                          'status status--' + shipment.status.toLowerCase()
                        "
                      >
                        {{ shipment.status }}
                      </span>
                    </td>

                    <td>
                      {{ formatDate(shipment.loadingDate) }}
                    </td>

                    <td>
                      {{ totalAssignedDevices(shipment) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Pagination
              :pageCount="pageCount"
              :data="paginatedData"
              :sizeperpage="sizeperpage"
              :pageNumber="pageNumber"
              :pages="pages"
              @goToLastPage="goToLastPage"
              @nextPage="nextPage"
              @handlePageChange="handlePageChange"
              @goToFirstPage="goToFirstPage"
              @prevPage="prevPage"
              @onchange="onchange"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- table end -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import TableSearch from "../../../components/TableSearch.vue";
import tableMixin from "../../../mixins/tableMixinWithBackend";
import Pagination from "../../../components/PaginationNew.vue";
import Drawer from "../../../components/Drawer.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import AddShipment from "../../Modals/AddShipment.vue";
import "intro.js/introjs.css";
import vClickOutside from "v-click-outside";
import moment from "moment";

export default {
  name: "ExportDispatchOverview",
  directives: {
    clickOutside: vClickOutside.directive,
  },
  mixins: [tableMixin],

  data() {
    return {
      isLoading: true,

      fullPage: true,
      sortOrders: {},
      dataTable: [],

      isModalVisible: false,
      condition: "all",

      viewDrawer: {},
      checkedShipments: [],
      shippingOptions: [
        { value: "all", label: "All" },
        { value: "ongoing", label: "Ongoing" },
        { value: "completed", label: "Completed" },
        { value: "created", label: "Created" },
        { value: "late", label: "Late" },
      ],
      containerToshowImeis: null,
    };
  },
  props: {
    showModal: Boolean,
    closeModal: Function,
  },
  components: {
    TableSearch,
    Pagination,
    Drawer,
    Loading,
    AddShipment,
  },
  mounted() {
    this.fetchShipments(this.params);
    this.$parent.$on("download-success", this.onDownloadSuccess);
  },

  computed: {
    ...mapGetters(["meta", "shipments", "shipmentSummary"]),

    paginationMeta() {
      return this.meta;
    },

    tableColumns() {
      return [
        [this.$t("shipmemt-id"), "shipmemt-id"],
        [this.$t("shipmemt-type"), "shipmemt-type"],
        [this.$t("container-number"), "container-number"],
        [this.$t("device-imei"), "device-imei"],
        [this.$t("e.t.d.")],
        [this.$t("e.t.a.")],

        [this.$t("vessel-name/flight_no"), "vessel-name"],
        [this.$t("status"), "status"],

        [this.$t("loading-date"), "loading-date"],
        [this.$t("no-of-devices"), "no-of-devices"],
      ];
    },
  },
  methods: {
    ...mapActions(["getShipments", "getShipmentSummary", "updateSelectedId"]),
    showImeis(event, containerNumber) {
      event.stopPropagation();
      this.containerToshowImeis = containerNumber;
    },
    hideImeis() {
      this.containerToshowImeis = null;
    },
    totalAssignedDevices(shipment) {
      if (shipment && shipment.containers) {
        return shipment.containers.reduce((total, container) => {
          return (
            total +
            (container.assignedDevices && container.assignedDevices.length
              ? container.assignedDevices.length
              : 0)
          );
        }, 0);
      }
      return 0;
    },

    calculateETA(startDate, endDate) {
      const start = moment(startDate);
      const end = moment(endDate);

      const duration = moment.duration(end.diff(start));
      const totalHours = duration.asHours();

      if (totalHours >= 24) {
        const days = Math.floor(duration.asDays());
        return days === 1 ? `${days} Day` : `${days} Days`;
      } else {
        const hours = Math.floor(totalHours);
        return hours === 1 ? `${hours} Hour` : `${hours} Hours`;
      }
    },

    formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY hh:mm A") : "-";
    },

    showdrawer(drawerInfo) {
      this.viewDrawer = drawerInfo;

      this.isModalVisible = true;
    },
    sortDevices({ target: { value } }) {
      // const validStatuses = ["ongoing", "completed"];
      // const status = validStatuses.includes(value) ? value : undefined;

      this.fetchShipments({
        ...this.params,
        keyword: this.searchQuery,
        status: value === "all" ? undefined : value,
        filterOperator: "and",
      });
      this.checkedShipments = [];
    },
    doSearch() {
      let params = {
        ...this.params,
        keyword: this.searchQuery,
      };

      this.fetchShipments(params);
    },
    fetchShipments(params) {
      this.isLoading = true;

      Promise.all([this.getShipments(params), this.getShipmentSummary()])
        .then((response) => {
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching shipments:", error);
          this.isLoading = false;
        });
    },

    handleCheck(id) {
      if (event.target.checked) {
        if (!this.checkedShipments.includes(id)) {
          this.checkedShipments.push(id);
        }
      } else {
        const index = this.checkedShipments.indexOf(id);
        if (index > -1) {
          this.checkedShipments.splice(index, 1);
        }
      }
      this.updateSelectedId(this.checkedShipments);
      // console.log(this.checkedShipments);
    },
    onDownloadSuccess() {
      this.checkedShipments = [];
      this.updateSelectedId(this.checkedShipments);
    },
    handleLoading(isLoading) {
      this.isLoading = isLoading;
    },
    headingCheckClick(event) {
      if (event.target.checked) {
        this.checkedShipments = this.paginatedData.map(
          (shipment) => shipment.id
        );
      } else {
        this.checkedShipments = [];
      }
      // Update the selected IDs in Vuex
      this.updateSelectedId(this.checkedShipments);
    },
  },
  watch: {
    shipments: {
      handler: function () {
        this.dataTable = this.shipments;
      },
      deep: true,
    },
    params() {
      this.fetchShipments(this.params);
    },
  },
};
</script>

<style scoped>
.img_div {
  width: 60.79px;
  height: 60px;
  gap: 0px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card_row {
  display: flex;
  gap: 1.5rem;
  padding: 0 1rem 0;
  justify-content: space-between;
}

.card_row > div {
  display: flex;
  padding: 2rem 1.8rem 2rem;
  border-radius: 10px;
  width: 370px;
  gap: 0.8rem;
  background-color: rgba(255, 255, 255, 1);
}

.available_container {
  display: flex;
  justify-content: space-between;
}

.card_content {
  display: flex;
  height: 49px;
  align-items: center;
  gap: 0.7rem;
}

.card_text {
  display: flex;
  flex-direction: column;
  gap: 5px;
  height: 49px;
  justify-items: center;
}

.card_text > .title {
  font-size: 22px;
  font-weight: 800;
  text-align: left;
}

.card_text > .info {
  font-size: 14px;
  font-weight: 400;
}

input[type="checkbox"] {
  position: relative;
  width: 20px;
  height: 20px;
  /* appearance: none;
  -webkit-appearance: none; */
  /* background-color: rgba(255, 255, 255, 1); */
  border: 2px solid rgba(153, 153, 153, 1);
  border-radius: 6px;
  cursor: pointer;
  accent-color: #213e7a;
}

/* input[type="checkbox"]:checked::before {
  content: "✔";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  color: rgba(64, 74, 87, 1);
} */

@media (max-width: 576px) {
  .card_row > div {
    width: 100%;
    margin: 0 auto;
  }
}

@media (min-width: 577px) and (max-width: 700px) {
  .card_row {
    gap: 0.6rem;
  }
  .card_row > div {
    width: 100%;
    padding: 2rem 1rem 2rem;
  }
}

@media (min-width: 701px) and (max-width: 767px) {
  .card_row > div {
    width: 30%;
    padding: 2rem 1rem 2rem;
  }
}

@media (min-width: 768px) and (max-width: 819px) {
  .card_row > div {
    width: 340px;
  }
}

@media (min-width: 820px) and (max-width: 854px) {
  .card_row > div {
    width: 240px;
  }
}

@media (min-width: 853px) and (max-width: 911px) {
  .card_row > div {
    width: 250px;
    padding: 2rem 1rem 2rem;
  }
}

@media (min-width: 912px) and (max-width: 991px) {
  .card_row > div {
    width: 270px;
  }
}

@media (min-width: 992px) and (max-width: 1023px) {
  .card_row > div {
    width: 340px;
  }
}

@media (min-width: 1024px) and (max-width: 1100px) {
  .card_row > div {
    width: 230px;
  }
}

@media (min-width: 1111px) and (max-width: 1180px) {
  .card_row > div {
    width: 250px;
  }
}
@media (min-width: 1181px) and (max-width: 1219px) {
  .card_row > div {
    width: 285px;
  }
}

@media (min-width: 1220px) and (max-width: 1279px) {
  .card_row > div {
    width: 290px;
  }
}

@media (min-width: 1280px) and (max-width: 1399px) {
  .card_row > div {
    width: 310px;
  }
}

@media (min-width: 1400px) {
  .card_row > div {
    width: 350px;
  }
}

.status {
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
  text-transform: capitalize;
}

.status--completed {
  background-color: #d1fae5; /* green-100 */
  color: #065f46; /* green-800 */
}

.status--ongoing {
  background-color: #fef3c7; /* yellow-100 */
  color: #92400e; /* yellow-800 */
}

.status--late {
  background-color: #fee2e2; /* red-100 */
  color: #991b1b; /* red-800 */
}

.status--created {
  background-color: #dbeafe; /* blue-100 */
  color: #1e3a8a; /* blue-800 */
}
.shadow {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  row-gap: 7px;
  min-width: 156px;
}

.outline-none:focus {
  outline: none;
}
</style>
